import { FC } from 'react';
import { useAffiliateEligibility } from '@/hooks/useAffiliateEligibility';
import type { UserProfile } from '@/integrations/supabase/types/user.types';
import { EligibilityCard } from './eligibility/EligibilityCard';
import { PremiumRequirement } from './eligibility/PremiumRequirement';
import { ActivityRequirement } from './eligibility/ActivityRequirement';
import { EligibilityWarning } from './eligibility/EligibilityWarning';
import { AffiliateRegistration } from './eligibility/AffiliateRegistration';
import { AffiliatePanel } from './eligibility/AffiliatePanel';

interface AffiliateEligibilityProps {
  userProfile?: UserProfile | null;
}

export const AffiliateEligibility: FC<AffiliateEligibilityProps> = ({ userProfile }) => {
  const { data: eligibilityData, isLoading } = useAffiliateEligibility(userProfile);

  if (isLoading) {
    return (
      <div className="animate-pulse space-y-4">
        <div className="h-4 bg-gray-200 rounded w-3/4"></div>
        <div className="space-y-2">
          <div className="h-4 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded w-5/6"></div>
        </div>
      </div>
    );
  }

  if (!eligibilityData) return null;

  return (
    <EligibilityCard>
      <div className="grid gap-4">
        <PremiumRequirement isPremium={eligibilityData.isPremium} />
        <ActivityRequirement activityMonths={eligibilityData.activityMonths} />
      </div>

      <EligibilityWarning 
        isPremium={eligibilityData.isPremium} 
        activityMonths={eligibilityData.activityMonths} 
      />

      {eligibilityData.isAffiliate ? (
        <AffiliatePanel />
      ) : eligibilityData.isEligible ? (
        <AffiliateRegistration userId={userProfile?.id || ''} />
      ) : (
        <div className="mt-4 p-4 bg-yellow-50 rounded-lg">
          <p className="text-yellow-700">
            Cuando cumplas todos los requisitos, podrás acceder al panel de Partners y comenzar a ganar comisiones.
          </p>
        </div>
      )}
    </EligibilityCard>
  );
};